import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import ttsAudio from "../assets/sound/tts_04.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/4.mp3";
import ttsAudio_jp from "../assets/sound/jp/4.mp3";
import ttsAudio_cn from "../assets/sound/cn/4.mp3";
import ttsAudio_mn from "../assets/sound/mn/4.mp3";

const About1 = () => {
    const { t,i18n } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { sex } = useParams();

    const audioRef = useRef(null);
    const inputRef = useRef(null);


    const [birth,SetBirth]=useState();

    console.log("lang:", i18n.language);
    console.log("ko resource:", i18n.getResourceBundle("ko", "translation"));
    console.log("ko target:", i18n.getResource("ko", "translation", "생년월일을 8자리(YYYYMMDD) 형식으로 입력해 주세요."));
    console.log("mn target:", i18n.getResource("mn", "translation", "생년월일을 8자리(YYYYMMDD) 형식으로 입력해 주세요."));

    const isValidYYYYMMDD = value => {
        if (!value) {
            return { ok: false, msg: t("생년월일을 입력해 주세요.") };
        }

        const s = String(value).trim();

        // 8 оронтой тоо эсэх шалгах
        if (!/^\d{8}$/.test(s)) {
            return { ok: false, msg: t("생년월일을 8자리(YYYYMMDD) 형식으로 입력해 주세요.") };
        }

        const yyyy = parseInt(s.slice(0, 4), 10);
        const mm = parseInt(s.slice(4, 6), 10);
        const dd = parseInt(s.slice(6, 8), 10);

        // Сар шалгах
        if (mm < 1 || mm > 12) {
            return { ok: false, msg: t("월이 올바르지 않습니다. (01–12)") };
        }

        // Өдөр шалгах
        if (dd < 1 || dd > 31) {
            return { ok: false, msg: t("일이 올바르지 않습니다. (01–31)") };
        }

        // Жинхэнэ огноо мөн эсэх (жишээ: 20250230 буруу)
        const d = new Date(yyyy, mm - 1, dd);
        const real = d.getFullYear() === yyyy && d.getMonth() === mm - 1 && d.getDate() === dd;

        if (!real) {
            return { ok: false, msg: t("올바르지 않은 날짜입니다. 예: 20250230은 불가능합니다.") };
        }

        // 1900 оноос өмнө хориглох (хүсвэл өөрчилж болно)
        if (yyyy < 1900) {
            return { ok: false, msg: t("1900년 이후 출생일을 입력해 주세요.") };
        }

        // Ирээдүйн огноо шалгах
        const today = new Date();
        const inputDate = new Date(yyyy, mm - 1, dd);

        if (inputDate > today) {
            return { ok: false, msg: t("미래 날짜는 입력할 수 없습니다.") };
        }

        return { ok: true, msg: "" };
    };


    const clickNext = () => {
        const result = isValidYYYYMMDD(birth);

        if (!result.ok) {
            swal(result.msg, "", "error");
            return;
        }

        navigate("/about2/" + name + "/" + sex + "/" + birth);
    };
    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    // 페이지 진입 시 input 자동 포커스 + 클릭
        useEffect(() => {
            const timer = setTimeout(() => {
                const el = inputRef.current;
                if (!el) return;
    
                el.focus();
    
                setTimeout(() => {
                    el.click();
                }, 100);
            }, 300);
    
            return () => clearTimeout(timer);
        }, []);

    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="input-area">
                <div className="step_area">STEP 3</div>
                <div className="title_area">
                    <h1 className="num_title">(3/5)</h1>
                    <h2 className="title">{t("생년월일을 입력해주세요")}</h2>
                </div>

                <div className="input_section">
                    <input
                        ref={inputRef}
                        type="text"
                        inputMode="numeric"
                        pattern="\d*"
                        maxLength={8}
                        className="text_nor md"
                        id="join_name"
                        autoComplete="off"
                        value={birth || ""}
                        placeholder={t("예) 19990101")}
                        onChange={e => {
                            // 숫자만 남기고 8자리로 제한
                            const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 8);
                            SetBirth(onlyDigits);
                        }}
                    />

                    <div className="start-btn-area">
                        <button className={`Next ${birth ? "active" : "disabled"}`} onClick={() => clickNext()}>
                            {t("확인")}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About1;
